// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.text-input-wrapper {
    position: relative;
    border: 1px solid var(--border-color);
    background-color: var(--input-bg-color);
    color: var(--text-color);
}

textarea.text-input-form-el {
    position: absolute;
    z-index: -1;
    pointer-events: none;
    opacity: 0;
    width: 0;
    left: 0;
    bottom: 0;
    height: 0;
}

pre.text-input {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 14px;
    margin: 0;
    padding: 0.25em;
    overflow: auto;
    cursor: text;
    text-align: left;
}

pre.text-input[contenteditable="true"] a {
    cursor: text;
    text-decoration: none;
}

pre.text-input-disabled {
    background-color: var(--input-bg-color-disabled);
}

pre.text-input-invalid {
    background-color: #FFAAAA;
}

pre.text-input-readonly {
    color: var(--text-color-disabled);
}

div.text-input-placeholder {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 1;
    padding: 0.25em;
    color: var(--text-color-disabled);
    pointer-events: none;
    border: 1px solid transparent;
}

div.text-input-resize-handle {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 0;
    height: 0;
    border-bottom: 10px solid var(--border-color);
    border-left: 10px solid transparent;
    z-index: 1;
    cursor: ns-resize;
}

span.text-input-link-tooltip {
    border: 1px solid var(--tooltip-border-color);
    background-color: var(--tooltip-bg-color);
    color: var(--tooltip-text-color);
    font-size: 75%;
    padding: 0.5em;
    border-radius: 0.5em;
    pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./../qwc2/components/widgets/style/TextInput.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,uCAAuC;IACvC,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,UAAU;IACV,QAAQ;IACR,OAAO;IACP,SAAS;IACT,SAAS;AACb;;AAEA;IACI,wDAAwD;IACxD,eAAe;IACf,SAAS;IACT,eAAe;IACf,cAAc;IACd,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,MAAM;IACN,UAAU;IACV,eAAe;IACf,iCAAiC;IACjC,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,QAAQ;IACR,SAAS;IACT,6CAA6C;IAC7C,mCAAmC;IACnC,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;IACzC,gCAAgC;IAChC,cAAc;IACd,cAAc;IACd,oBAAoB;IACpB,oBAAoB;AACxB","sourcesContent":["div.text-input-wrapper {\n    position: relative;\n    border: 1px solid var(--border-color);\n    background-color: var(--input-bg-color);\n    color: var(--text-color);\n}\n\ntextarea.text-input-form-el {\n    position: absolute;\n    z-index: -1;\n    pointer-events: none;\n    opacity: 0;\n    width: 0;\n    left: 0;\n    bottom: 0;\n    height: 0;\n}\n\npre.text-input {\n    font-family: \"Helvetica Neue\",Helvetica,Arial,sans-serif;\n    font-size: 14px;\n    margin: 0;\n    padding: 0.25em;\n    overflow: auto;\n    cursor: text;\n    text-align: left;\n}\n\npre.text-input[contenteditable=\"true\"] a {\n    cursor: text;\n    text-decoration: none;\n}\n\npre.text-input-disabled {\n    background-color: var(--input-bg-color-disabled);\n}\n\npre.text-input-invalid {\n    background-color: #FFAAAA;\n}\n\npre.text-input-readonly {\n    color: var(--text-color-disabled);\n}\n\ndiv.text-input-placeholder {\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    z-index: 1;\n    padding: 0.25em;\n    color: var(--text-color-disabled);\n    pointer-events: none;\n    border: 1px solid transparent;\n}\n\ndiv.text-input-resize-handle {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n    width: 0;\n    height: 0;\n    border-bottom: 10px solid var(--border-color);\n    border-left: 10px solid transparent;\n    z-index: 1;\n    cursor: ns-resize;\n}\n\nspan.text-input-link-tooltip {\n    border: 1px solid var(--tooltip-border-color);\n    background-color: var(--tooltip-bg-color);\n    color: var(--tooltip-text-color);\n    font-size: 75%;\n    padding: 0.5em;\n    border-radius: 0.5em;\n    pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
